<template>
  <div class="options">
    <p class="colorTitle">{{ $t('CustomSpus.AddToCart.colorTitle') }}</p>
    <div class="colors">
      <div ref="hiddenContainerColor"
           class="hidden"></div>
      <template v-for="item in colors">
        <a-tooltip>
          <template #title>{{ item.name }}</template>
          <div v-if="alt_image.find((alt: any) => alt.color.value == item.value)">
            <div v-for="alt in alt_image">
              <img v-if="alt.color.value == item.value"
                   :src="alt.alt_image"
                   :class="['color-item', selectedColor?.value === item.value ? 'color-selected' : '']"
                   @click="colorChange(item)" />
            </div>
          </div>
          <div v-else-if="alt_image.some((alt: any) => alt.color.value != item.value)">
            <div :class="['color-item', selectedColor?.value === item.value ? 'color-selected' : '']"
                 :style="{ background: item.value, backgroundImage: `url(${item.image})` }"
                 @click="colorChange(item)"></div>
          </div>
          <div v-else-if="alt_image.length < 1">
            <div :class="['color-item', selectedColor?.value === item.value ? 'color-selected' : '']"
                 :style="{ background: item.value, backgroundImage: `url(${item.image})` }"
                 @click="colorChange(item)"></div>
          </div>
          <div v-else>
            <div v-if="hiddenContainerColor && is_custom"
                 class="viewer">
              <ImageCustomizeViewer v-if="image"
                                    :id="image.id + ''"
                                    mode="view"
                                    :container="hiddenContainerColor"
                                    :template-basic-parameters="templateBasicParameters(toUrl(findCustomableImage(selectedColor as any, image))!, selectedColor?.value!, image.width, image.height)" />
            </div>
          </div>
        </a-tooltip>
      </template>
    </div>
    <p class="sizeTitle">{{ $t('CustomSpus.AddToCart.sizeTitle') }}</p>
    <div class="size-content">
      <div v-for="item in sizes"
           :key="item"
           :class="['size-item', selectedSize === item ? 'size-selected' : null]"
           @click="sizeChange(item)">
        <span>{{ item }}</span>
      </div>
    </div>
    <p class="countTitle">{{ $t('CustomSpus.AddToCart.countTitle') }}</p>
    <a-input v-model:value="quantity"
             class="quantity-input">
      <template #addonBefore>
        <div class="input-change"
             :class="quantity <= 1 ? 'input-disabled' : ''"
             @click="quantity <= 1 ? '' : qualityChange('minus')">
          <minus-outlined :class="quantity <= 1 ? 'input-disabled' : ''" />
        </div>
      </template>
      <template #addonAfter>
        <div class="input-change"
             :class="quantity > 100000 ? 'input-disabled' : ''"
             @click="quantity > 100000 ? '' : qualityChange('plus')">
          <plus-outlined :class="quantity > 100000 ? 'input-disabled' : ''" />
        </div>
      </template>
    </a-input>
    <div v-for="item in custom_price"
         :key="item.id">
      <div v-if="is_custom"
           class="technology countTitle">
        <span>{{ item.name + '(' + item.customized_areas_scale_title + ')' }} {{
          $t('CustomSpus.AddToCart.technology')
        }}</span>
        <a-radio-group v-model:value="item.technology"
                       class="technology-radio">
          <a-radio v-for="(ite, index) in item.technologies"
                   :key="index"
                   :value="ite">{{ ite.name }}</a-radio>
          <a-radio v-if="item.technologies?.length === 0"
                   :value="item.technology!">{{ item.technology!.name }}</a-radio>
        </a-radio-group>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue"
import { toUrl } from "@/utils"
import { findCustomableImage, templateBasicParameters } from '../../utils'
import { ImageCustomizeEditor as ImageCustomizeViewer } from '@iota-cn/ui-components'
defineProps<{
  colors: any
  sizes: any
  image: any
  custom_price: any
  is_custom: boolean
  alt_image: any
  selectedColor: any
  selectedSize: string
}>()
const hiddenContainerColor = ref()
const emits = defineEmits(['qualityChange', 'colorChange', 'sizeChange'])

const quantity = ref<number>(1)
const qualityChange = (event: any) => {
  switch (event) {
    case 'minus':
      quantity.value--
      break
    case 'plus':
      quantity.value++
      break
  }
  emits("qualityChange", { quantity: quantity.value })
}
const sizeChange = (value: string) => {
  emits('sizeChange', value)
}
const colorChange = (value: any) => {
  emits('colorChange', value)
}
</script>
<style lang="less" scoped>
.options {

  .colorTitle,
  .sizeTitle,
  .countTitle {
    margin: 20px 0 10px 0;
    font-size: 16px;
  }

  .technology-radio {
    margin-left: 24px;
  }

  .hidden {
    width: 35px;
    height: 35px;
    position: absolute;
    visibility: hidden;
    display: block;
  }

  .viewer {
    width: 35px;
    height: 35px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .colors {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    align-items: center;

    .color-item {
      width: 35px;
      height: 35px;
      border: 1px solid #cdcdcd;
      cursor: pointer;
    }

    .color-selected {
      border: 1px solid #111;
    }
  }

  .size-content {
    display: flex;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 10px;

    .size-item {
      border: 1px solid #d9d9d9;
      padding: 0 10px;
      cursor: pointer;
      height: 40px;
      min-width: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .size-selected {
      background-color: #111111;
      color: white;
    }
  }

  .quantity-input {
    width: 124px;
    text-align: center;

    :deep(.ant-input-group-addon) {
      padding: 0;
      width: 32px;
      height: 32px;
    }

    :deep(.ant-input) {
      height: 32px;
      padding: 0;
    }

    .input-change {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #F6F6F6;
    }

    .input-disabled {
      cursor: not-allowed;
    }
  }
}
</style>